"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLOR = exports.SYMBOL = exports.ZINDEX = exports.SIZE = void 0;
var SIZE;
(function (SIZE) {
    SIZE[SIZE["SITE_WIDTH"] = 1300] = "SITE_WIDTH";
    SIZE[SIZE["SITE_PADDING"] = 32] = "SITE_PADDING";
    SIZE[SIZE["PAGE_WIDTH"] = 1000] = "PAGE_WIDTH";
    SIZE[SIZE["TOP_NAV_HEIGHT"] = 64] = "TOP_NAV_HEIGHT";
    SIZE[SIZE["SIDEBAR_WIDTH"] = 300] = "SIDEBAR_WIDTH";
})(SIZE || (exports.SIZE = SIZE = {}));
var ZINDEX;
(function (ZINDEX) {
    ZINDEX[ZINDEX["TOP_NAV"] = 1000] = "TOP_NAV";
    ZINDEX[ZINDEX["SIDEBAR"] = 1001] = "SIDEBAR";
    ZINDEX[ZINDEX["CONTEXT"] = 1002] = "CONTEXT";
    ZINDEX[ZINDEX["PROGRESS"] = 2000] = "PROGRESS";
    ZINDEX[ZINDEX["MODAL"] = 4000] = "MODAL";
    ZINDEX[ZINDEX["CURSOR"] = 1000000] = "CURSOR";
})(ZINDEX || (exports.ZINDEX = ZINDEX = {}));
var SYMBOL;
(function (SYMBOL) {
    SYMBOL["CHECKMARK"] = "\u2713";
    SYMBOL["CROSS"] = "\u2717";
    SYMBOL["NIL"] = "\u2205";
    SYMBOL["ELLIPSIS"] = "\u2026";
    SYMBOL["MDASH"] = "\u2014";
    SYMBOL["NDASH"] = "\u2013";
    SYMBOL["FDASH"] = "\u2012";
    SYMBOL["CTRL"] = "\u2303";
    SYMBOL["CMD"] = "\u2318";
    SYMBOL["ALT"] = "\u2325";
    SYMBOL["SHIFT"] = "\u21E7";
})(SYMBOL || (exports.SYMBOL = SYMBOL = {}));
var COLOR;
(function (COLOR) {
    COLOR["LINK"] = "#0089ff";
})(COLOR || (exports.COLOR = COLOR = {}));
